export const gmailLabelsToIgnore = [
  'UNREAD',
  'CATEGORY_PERSONAL',
  'CATEGORY_UPDATES',
  'IMPORTANT',
  'CATEGORY_FORUMS',
  'SENT',
];
export const GMAIL_LABELS_CUT_OFF = 3;
